import { createUserId } from "@omni/services/tracking/trackers/utils";
import { AnalyticsEvent } from "@omni/types/components/tracking/analyticsEvent";
import { getJsonPayload, hasWindow } from "@omni/utils/dom.utils";
import * as SessionStorage from "@omni/utils/sessionStorage.utils";

import { $CustomerModuleName } from "@/redux/modules/api/data/customer/customer.types";
import { getApiDataState } from "@/redux/utils";

import { EnrichedAnalyticsEvent, PageInfo, UserInfo } from "../analytics.types";

const getPageInfo = (): PageInfo => {
    const pageImpressionElement: HTMLElement | null = document.querySelector(
        '[data-tracking-event="page-impression"]'
    );
    if (pageImpressionElement) {
        const pageInfo: Omit<PageInfo, "timestamp"> = getJsonPayload(
            pageImpressionElement
        );

        return {
            name: pageInfo.name,
            url: pageInfo.url,
            locale: pageInfo.locale,
            language: pageInfo.language,
            category: pageInfo.category,
            type: pageInfo.type,
            variant: pageInfo.variant,
            timestamp: Date.now()
        };
    }
    return {
        name: "",
        url: "",
        locale: "",
        language: "",
        category: "",
        type: "",
        variant: "",
        timestamp: Date.now()
    };
};

export const getUserInfo = (): UserInfo => {
    if (!hasWindow()) {
        return {
            loginStatus: false
        };
    }

    const customer = getApiDataState(
        window.storeManager.getState(),
        $CustomerModuleName
    )?.data;

    const email = customer?.email || SessionStorage.getItem("customer_email");
    const customerType = customer?.customerType;

    if (email) {
        return {
            loginStatus: true,
            clientID: createUserId(email),
            customerType: customerType || null
        };
    } else {
        return {
            loginStatus: false
        };
    }
};

export const enrichEvent = (event: AnalyticsEvent): EnrichedAnalyticsEvent => {
    return {
        ...event,
        payload: {
            ...event.payload,
            pageInfo: getPageInfo(),
            userInfo: getUserInfo()
        }
    };
};
